import { UniqueValueValidator } from './unique-value-validator';
import { RegExpPatternValidator } from './regexp-pattern-validator';
import { MaxItemsValidator } from './max-items-validator';

export class FormValidators {
  public static readonly nonUniqueError = UniqueValueValidator.nonUniqueError;
  public static readonly regexpError = RegExpPatternValidator.regExpError;
  public static readonly maxItemsError = MaxItemsValidator.maxItemsError;

  public static readonly uniqueValue = UniqueValueValidator.uniqueValue;
  public static readonly regExp = RegExpPatternValidator.regExp;
  public static readonly maxItems = MaxItemsValidator.maxItems;
}
